import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import HelpIcon from "../UI/HelpIcon/HelpIcon";
import { AlertInfo } from "../UI/StandardAlerts/StandardAlerts";
const useHelpIcon = (helpText) => {
    const [showHelpText, setShowHelpText] = React.useState(false);
    return React.useMemo(() => ({
        icon: (_jsx(HelpIcon, { size: "lg", onClick: () => setShowHelpText((text) => !text), title: helpText })),
        text: showHelpText && _jsx(AlertInfo, { message: helpText }),
    }), [helpText, showHelpText]);
};
export default useHelpIcon;
